module.exports = __webpack_public_path__ + "img/6_59.a8522a58.png";